export default {
      id: "hand-usage",
      viewBox: "0 0 60 70",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#hand",
      toString: function () {
        return this.url;
      }
    }